import { useContext } from 'react';
import { StoreContext } from '../../store';
import './index.css';

import WWMSlider from './slider';
import Features from './features';

const WhyUs = () => {
  const { state } = useContext(StoreContext);
  const { isMobile } = state;
  return (
    <div className="wu-container w-full h-fit">
      <div className="w-full h-auto">
        <div className="bg-[#1c293a] text-white text-3xl text-center py-12">
          <div className="px-4">WHAT MAKES WALKSPAN DIFFERENT</div>
        </div>
        <div className='flex h-auto md:h-[500px] bg-abstract'>
          <div className="max-w-screen-xl text-center flex m-auto px-8">
            <div className="my-auto text-[20px] !leading-10 lg:text-2xl">
              Walkspan’s <b>advanced neighborhood search</b> tool equips
              agents with comprehensive, lifestyle-focused insights to help
              clients find their <b>ideal community</b>. Combining AI with real
              estate and urban planning expertise, Walkspan offers in-
              depth, accessible profiles of neighborhood walkability and
              livability, information unmatched on any single platform.
              Delivered as a seamless SaaS solution, it integrates
              effortlessly-either as a widget or through secure login without
              the need for server changes.
            </div>
          </div>
        </div>
      </div>
      <div className="w-full">
        <div className="bg-[#1c293a] text-white text-3xl text-center py-12">
          <div className="px-4">WHAT WE MEASURE</div>
        </div>
        <div className={`wwm-section h-auto w-full text-center flex mx-auto`}>
          <WWMSlider isMobile={isMobile} />
        </div>
      </div>
      <Features />
    </div>
  )
};

export default WhyUs;